module.exports = __webpack_public_path__ + "static/img/apply_banner_04.4b4e7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/apply_banner_04.png
// module id = 9Ocv
// module chunks = 34